import moment from "moment";
import dayjs from 'dayjs';
//--------capital-all-first-letter----------------
export const capitalize = (str) => {
    if (!str || typeof str !== "string") return "";

    return str
        .toLowerCase() // Ensure the whole string is in lowercase
        .split(" ") // Handle multiple words
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
};

//--------date-format-----11/03/2025----------------
export const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    if (isNaN(date)) return "Invalid Date";

    return date.toLocaleDateString("en-GB"); // DD/MM/YYYY format
};
//--------date-format-month----12 May 2025----------------
export const dateMonthFormat = (date) => {
    if (!date) return '';
    return moment(date).format("DD MMM YYYY");
};
// ---------format-indian-price------1234567-to-₹12,34,567---
export const indFormatPrice = (price) => {
    if (price === undefined || price === null || isNaN(price)) return "₹0";

    return `₹${Number(price).toLocaleString("en-IN")}`;
};

//----------Open-file-in-a-new-tab----------------
export const openFileInNewTab = async (url) => {
    if (!url) return;

    const fileExtension = url.split(".").pop().toLowerCase();

    if (["pdf", "doc", "docx", "xls", "xlsx", "ppt", "pptx", "txt"].includes(fileExtension)) {
        const previewUrl = `https://docs.google.com/gview?url=${encodeURIComponent(url)}&embedded=true`;
        window.open(previewUrl, "_blank");
    } else {
        window.open(url, "_blank");
    }
};



// ----------Download-file-immediately--Download----------------

export const downloadFile = async (fileUrl, fileName = null) => {
    if (!fileUrl) return; // Ensure fileUrl is provided

    try {
        // Fetch the file and convert it to a blob
        const response = await fetch(fileUrl);
        if (!response.ok) throw new Error("Failed to fetch the file");

        const blob = await response.blob();

        // Create a link element
        const link = document.createElement("a");
        const blobUrl = URL.createObjectURL(blob);
        link.href = blobUrl;

        // Determine the filename
        const updatedFileName = fileName || fileUrl.split("/").pop() || "download";
        link.download = updatedFileName;

        // Trigger download and clean up
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(blobUrl); // Free up memory
    } catch (error) {
        console.error("Error downloading file:", error);
    }
};

//-----Helper-function-to-convert-bytes-to-KB, MB, or GB------------
export const formatFileSize = (sizeInBytes) => {
    if (!sizeInBytes || isNaN(sizeInBytes) || sizeInBytes < 0) {
        return '';
    }

    if (sizeInBytes >= 1024 * 1024 * 1024) {
        return (sizeInBytes / (1024 * 1024 * 1024)).toFixed(2) + ' GB';
    } else if (sizeInBytes >= 1024 * 1024) {
        return (sizeInBytes / (1024 * 1024)).toFixed(2) + ' MB';
    }
    return (sizeInBytes / 1024).toFixed(2) + ' KB';
};

//------------------file-extension-----------------------
export const showExtension = (name) => {
    if (!name || typeof name !== 'string') return '';
    const lastDotIndex = name.lastIndexOf('.');
    return lastDotIndex !== -1 ? name.slice(lastDotIndex) : '0';
};

// ----------give-days-it-is-return-start-date-and-end-date---------------
export const getStartAndEndDate = (days, setState) => {
    if (!days || typeof days !== 'number' || days < 0) {
        return '';
    }
    const endDate = new Date(); // Today
    const startDate = new Date(); // Today - days
    startDate.setDate(endDate.getDate() - days);

    const result = {
        startDate: startDate.toISOString(),
        endDate: endDate.toISOString()
    };

    if (setState && typeof setState === 'function') {
        // setState(result);
        setState((prev) => ({ ...prev, ...result }))
    }

    return result;
};

// ---------format-Time-stamp----input-(1746695101011)--output-(07 May 2025, 02:15 PM)-----
export const formatTimestamp = (time) => {
    if (!time) return '';

    const date = new Date(time);

    // Format: DD MMM YYYY, HH:MM AM/PM
    return date?.toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    });
};
//-----------------------
export const formatUnixTimestamp = (timestamp, format = 'DD MMM YYYY HH:mm:ss') => {
    if (!timestamp) return 'Invalid timestamp';

    // If it's in seconds, convert to milliseconds
    const ts = timestamp.toString().length === 10 ? timestamp * 1000 : timestamp;

    return dayjs(ts).format(format);
};
// -------two-decimal-number-show-after-point--------1944787.1300000001---to--1,944,787.13-------
export const formatDecimalNumber = (value, decimals = 2) => {
    if (isNaN(value) || value === null || value === undefined) return '0.00';
    return Number(value)
        .toFixed(decimals)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
// ------format-time----------00:00-to--12:00 AM-------
export const formatTimeTo12Hour = (timeString) => {
    if (!timeString) return '';
    return moment(timeString).format("h:mm A");
};


// ------convert-to-hour-minute-second------------------------
// export const formatDurationHMS = (decimalHours) => {
//   if (decimalHours === 0 || decimalHours === null || decimalHours === undefined) {
//     return "0 hrs : 0 mins : 0 secs";
//   }

//   const totalSeconds = Math.floor(decimalHours * 3600); // convert hours to seconds

//   const hours = Math.floor(totalSeconds / 3600);
//   const minutes = Math.floor((totalSeconds % 3600) / 60);
//   const seconds = totalSeconds % 60;

//   return `${hours} hrs : ${minutes} mins : ${seconds} secs`;
// };

export const formatDurationHMS = (totalMinutes) => {
    if (!totalMinutes || isNaN(totalMinutes)) {
        return "0 hrs : 0 mins : 0 secs";
    }

    const totalSeconds = totalMinutes * 60;

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours} hrs : ${minutes} mins : ${seconds} secs`;
};


// -----------5-to-00:05------75-to-01:15------------
// export const convertMinutesToHHMM = (minutes) => {
//     if (!minutes) return '00:00'
//     const roundedMinutes = Math.round(minutes);  // 🔁 Round the input
//     const hrs = Math.floor(roundedMinutes / 60).toString().padStart(2, '0');
//     const mins = (roundedMinutes % 60).toString().padStart(2, '0');
//     return `${hrs}:${mins}`;
// };
export const convertMinutesToHHMM = (minutes) => {
  if (!minutes) return '00:00';

  const decimal = minutes % 1; // Get decimal part
  let roundedMinutes;

  if (decimal > 0.30) {
    roundedMinutes = Math.ceil(minutes);  // Round up
  } else {
    roundedMinutes = Math.floor(minutes); // Round down
  }

  const hrs = Math.floor(roundedMinutes / 60).toString().padStart(2, '0');
  const mins = (roundedMinutes % 60).toString().padStart(2, '0');

  return `${hrs}:${mins}`;
};

// -----------(15613.124282982793-----to-------5613.12----------------
export const formatToDecimal = (value, digits = 2) => {
    if (!value) return '0'
    const num = parseFloat(value);
    return isNaN(num) ? Number(0).toFixed(digits) : num.toFixed(digits);
};

// ----------2025-05-01T23:55:00.000Z------to------11:55 PM----------------
export const formatToTimeOnly = (datetime) => {
    if (!datetime) return 'N/A';
    return moment(datetime).format('h:mm A');
};
// -------79.59-to-79--------------------------
export const getBeforeDecimalValue = (value) => {
    if (!value && value !== 0) return 0; // handles null, undefined, "", etc.
    const num = +value; // converts string to number (e.g., "45.78" → 45.78)
    return isNaN(num) ? 0 : Math.floor(num);
};
// -------------format-all-type-of-date---------------------
// Format	Output
// "DD MMM YYYY"	01 May 2025
// "MMMM D, YYYY"	May 1, 2025
// "DD-MM-YYYY"	01-05-2025
// "MM/DD/YYYY"	05/01/2025
// "YYYY-MM-DD"	2025-05-01 (original forma
export const formatAllDate = (date, outputFormat = "YYYY-MM-DD") => {
    if (!date) return "";
    const moment = require("moment"); // or import moment from 'moment';
    return moment(date).format(outputFormat);
};

// --------format-text--------------------
// formatText("amresh pandey", "first"); // Amresh pandey
// formatText("amresh pandey", "title"); // Amresh Pandey
// formatText("amresh pandey", "upper"); // AMRESH PANDEY

export const formatText = (text = "", mode = "first") => {
  if (!text) return "";

  switch (mode) {
    case "first": // Capitalize first letter only
      return text.charAt(0).toUpperCase() + text.slice(1);
    
    case "title": // Capitalize first letter of every word
      return text
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

    case "upper": // All uppercase
      return text.toUpperCase();

    default:
      return text;
  }
};